import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { requestAssets } from 'store/api/cuverse-api/assets/assets.service';
import {
  AssetsResponseSchema,
  TAssetsData,
} from 'store/api/cuverse-api/assets/types/assets-response.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const requestAssetsData = createAsyncThunk(
  'assets/fetch',
  async (): Promise<TAssetsData> => {
    return await requestWithZodSchema(requestAssets, AssetsResponseSchema)
      .then((response) => response)
      .catch((error) => {
        notifyError(i18n.t('notifyMessages.assets.dataLoadError'));
        throw error;
      });
  },
);
